 <!-- DELETE-MODAL -->
 <div class="master-modal delete-modal" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <!-- Modal-Header -->
      <div class="modal-header">
        <h4 class="modal-title">Refund Order</h4>
        <div class="modal_close_btn">
          <span (click)="dialogClose('no')" class="modal-close"><i class="material-icons">close</i></span>
        </div>
      </div>
      <form [formGroup]="refundForm" (ngSubmit)="refundOrder()">
        <!-- {{refundForm.value |json}} -->
      <!-- Modal-Body -->
      <!-- Modal content-->
      <perfect-scrollbar class="modal-body-scrollbar">
        <div mat-dialog-content>
          <div class="modal-body">
            <div fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row" fxLayout.xs="column"
              fxLayoutAlign="start stretch" fxLayoutGap="8px">
              <div fxLayout="column" fxFlex="100" fxFlexFill>
                <div class="notification-delete">
                  <p>Do you really want to refund the Order?</p>
                </div>

                <!-- Message-TEXT-AREA-->
                <div class="custom-form-group mt-20">
                  <label class="custom-label fx-display" for=""> Refund Amount <span class="star">*</span> </label>
                  <div class="custom-form-control">
                    <mat-form-field appearance="outline">
                      <input matInput formControlName="amount" placeholder="Enter refund amount" />
                      <mat-error *ngIf="amount.invalid && ( amount.dirty || amount.touched )">
                        <span *ngIf="amount.hasError('required')">Please provide a valid value</span>
                        <span *ngIf="amount.hasError('max')">You can refund upto {{refundRemaining.toFixed(2)}</span>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>


                <div class="notification-delete" *ngIf="data.refunds && data.refunds.length">
                  <p>Previous Refunds :</p>
                  <div>
                    <table>
                      <thead>
                        <tr>
                          <th> Payment Intent Id </th>
                          <th> Amount </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let singleRefund of data.refunds">
                          <td> {{singleRefund.payment_intent_id}} </td>
                          <td> {{singleRefund.amount.toFixed(2)}} </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <th> Total Amount Refunded </th>
                          <th> {{refundedAmount.toFixed(2)}}</th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </perfect-scrollbar>
      <!-- Modal-Footer -->
    <div class="modal-footer">
      <div mat-dialog-actions class="modal_footer">
        <!-- <button mat-button (click)="dialogClose('no')" class="modal-cancel-btn modal-footer-btn">
          <span>Cancel</span>
        </button> -->
        <button mat-button class="modal-save-btn global-btn modal-footer-btn">
          <span>Refund Order</span>
        </button>
      </div>
    </div>
  </form>
    </div>
  </div>
</div>
